module.exports = __webpack_public_path__ + "static/media/deleteIcon.e37568d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/deleteIcon.svg
// module id = 1269
// module chunks = 0